import axios from 'axios';
import { standardizeObjectKeys } from '../utils/DataTransformation';
import { endpoints } from '../store/StaticVariables';

const featureServiceUrl = endpoints.trends + '0/query';

export const NationalFeatureRequest = async (props = {}) => {
    const { token = '' } = props;
    const tokenText = endpoints.useToken && token ? '&token=' + token : '';
    return axios.get(featureServiceUrl + '?where=Type%3D%27ttm%27+OR+Type%3D%27year%27&outFields=*&returnGeometry=false&f=pjson' + tokenText).then((res) => {
        if (res.data.error) throw new Error('ERROR in National Feature Request', { cause: res.data.error });
        return res.data.features;
    });
};
export const NationalDataEndDateRequest = async (props = {}) => {
    const { token = '' } = props;
    const tokenText = endpoints.useToken && token ? '&token=' + token : '';
    return axios.get(featureServiceUrl + '?where=Type%3D%27ttm%27&outFields=*&returnGeometry=false&f=pjson' + tokenText).then((res) => {
        // console.log('Res of nat feature request');
        // console.log(res);
        if (res.data.error) throw new Error('ERROR in National Feature Request', { cause: res.data.error });
        return res.data.features;
    });
};

// Returned national feature attributes
// {
//     "OBJECTID": 203,
//     "GEOID": "USA",
//     "Intent": "Suicide",
//     "Period": 1704067200000,
//     "Count": 4036,
//     "Rate": 1.20508226,
//     "Type": "year"
// }

export const GetAllNationalData = async (props = {}) => {
    var output = {};
    const rawFeatures = await NationalFeatureRequest(props);
    var defaultFeature = {
        NAME: 'United States',
        GEOID: '1'
        // Count_SYM_All: 0,
        // Count_SYM_Homicide: 0,
        // Count_SYM_Suicide: 0,
        // ED_Rate_M: 0,
        // ED_Rate_SYM: 0,
        // Rate_M_ED: 0,
        // Rate_SYM_ED: 0,
        // Rate_M_All: 0,
        // Rate_M_Homicide: 0,
        // Rate_M_Suicide: 0,
        // Rate_SYM_All: 0,
        // Rate_SYM_Homicide: 0,
        // Rate_SYM_Suicide: 0,
        // Rate_ED: 0,
        // Rate_CI_ED: 0,
        // ED_Rate: 0,
        // ED_Rate_CI: 0
    };

    // Map feature attributes to standard app attributes
    for (var i = 0; i < rawFeatures.length; i++) {
        var info = rawFeatures[i].attributes;
        let year = info.Type === 'TTM' ? 'ttm' : new Date(info.Period).getUTCFullYear();
        let intent = info.Intent === 'ALL' ? 'All' : info.Intent;
        if (!(year in output)) {
            output[year] = JSON.parse(JSON.stringify(defaultFeature));
        }
        let rateKey = 'rate_' + intent;
        let rateSymKey = 'rate_sym_' + intent;
        let rateCIKey = 'rate_ci_' + intent;
        output[year][rateKey] = info.Rate;
        output[year][rateKey + '_m'] = 0;
        output[year][rateCIKey] = info.Rate;
        output[year][rateSymKey] = 1;

        let countKey = 'count_sup_' + intent;
        let countSymKey = 'count_sym_' + intent;
        output[year][countKey] = info.Count;
        output[year][countSymKey] = 1;
    }
    const standardized = {};
    Object.keys(output).forEach((key) => {
        standardized[key] = standardizeObjectKeys(output[key]);
    });
    return standardized;
};
const monthsArr = ['Janunary', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'];
//returns a date object whose month is ajusted by the number specified *can use negative number
function add_months(dt, n) {
    return new Date(dt.setMonth(dt.getUTCMonth() + n));
}
function dynamicBackDateString(endDate) {
    const backDate = add_months(new Date(endDate), -11);
    return monthsArr[backDate.getUTCMonth()] + ' ' + backDate.getUTCFullYear();
}
function manualBackDateString(endDate) {
    const dt = new Date(endDate);
    const monthOffsetArr = ['February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December', 'Janunary'];
    const newMonth = monthOffsetArr[dt.getUTCMonth()];
    const newYear = dt.getUTCMonth === 11 ? dt.getUTCFullYear() : dt.getUTCFullYear() - 1;
    return newMonth + ' ' + newYear;
}

// This function will create an array of objects
// It will use the service to get all timestaps for all intents in TTM
export const getRecent12Months = async (props = {}) => {
    const rawFeatures = await NationalDataEndDateRequest(props);
    const dates = {};
    rawFeatures.forEach((f) => {
        const endTime = f.attributes.Period;
        const endDate = new Date(endTime);
        const endDateString = monthsArr[endDate.getUTCMonth()] + ' ' + endDate.getUTCFullYear();
        // const dynBackdateString = dynamicBackDateString(endTime);
        const manBackdateString = manualBackDateString(endTime);
        const intentSlug = f.attributes.Intent.toLowerCase();
        dates[intentSlug] = {
            endTime,
            startDateString: manBackdateString,
            endDateString
        };
    });
    return dates;
};
//jan feb mar apr may june july aug sep oct nov dev
